/* ══════════ State ══════════ */
export const state = {
  courses: [], decks: [], cards: [], log: [],
  goals: { weekly: 100 },
  progress: { rated: 0, xp: 0, coins: 0, gems: 0, equipped: null, unlocked: [], owned: [], room: [], freezes: 0, frozen: [], lastBonus: '', roomTheme: 'default', catColor: 'orange', ownedThemes: [], ownedColors: [], best: { correct: 0, wrong: 0 }, cur: { correct: 0, wrong: 0 }, remindersOff: false },
  /* `nameAuto` merkt sich, ob der Anzeigename abgeleitet oder selbst gewählt
     ist. Nur ein abgeleiteter darf beim Umbenennen mitwandern – einen selbst
     gewählten Namen hinter dem Rücken zu ändern wäre übergriffig. */
  profile: { name: '', nameAuto: true, age: '', context: '', school: '', bio: '' },
  cal: { events: [], blocked: [] },
  unis: [],
  buddyImg: null,
  selCourse: null, selDecks: new Set(), openCourses: new Set(),
  showArchived: false, view: 'dashboard',
  mode: 'forward', studyMode: 'flip', focus: 'due-first', size: 10,
  session: null, filter: 'all', search: '', tagFilter: null,
  calMonth: new Date(), calSel: null, coll: null,
  me: null, social: { friends: 0, published: 0, likesReceived: 0, downloads: 0 }, comTab: 'library', lbSort: 'xp', comSubject: '',
};


/* ── Zurück auf Anfang ────────────────────────────────────────────────────
   Wird beim Kontowechsel gebraucht: meldet sich in demselben Browser ein
   ANDERES Konto an, darf nichts vom vorherigen übrig bleiben.

   `state` wird dabei bewusst in place überschrieben, nicht ersetzt – überall
   sonst hält der Code eine Referenz auf genau dieses Objekt. */
const ANFANG = JSON.stringify({
  courses: [], decks: [], cards: [], log: [],
  goals: state.goals, progress: state.progress, profile: state.profile, cal: state.cal,
});
export function resetUserState() {
  Object.assign(state, JSON.parse(ANFANG));
  // Mengen überstehen den JSON-Umweg nicht.
  state.selDecks = new Set();
  state.openCourses = new Set();
  state.selCourse = null;
  state.session = null;
  state.buddyImg = null;
  state.social = { friends: 0, published: 0, likesReceived: 0, downloads: 0 };
}
